require("core-js/modules/es6.string.small");

require("core-js/modules/es6.object.define-property");

!function (n, r) {
  "object" == typeof exports && "undefined" != typeof module ? r(exports, require("styled-components")) : "function" == typeof define && define.amd ? define(["exports", "styled-components"], r) : r((n = n || self)["@tinacms/styles"] = {}, n.styled);
}(this, function (n, r) {
  "use strict";

  var o = "default" in r ? r["default"] : r;

  function e(n, r) {
    return Object.defineProperty ? Object.defineProperty(n, "raw", {
      value: r
    }) : n.raw = r, n;
  }

  function t(n) {
    return n.theme.tinacms || i;
  }

  var i = {
    color: {
      primary: {
        light: "#2296FE",
        medium: "#0084ff",
        dark: "#0574E4"
      },
      error: {
        light: "#EB6337",
        medium: "#EC4815",
        dark: "#DC4419"
      },
      grey: {
        0: "#FFFFFF",
        1: "#F6F6F9",
        2: "#EDECF3",
        3: "#E1DDEC",
        4: "#B2ADBE",
        5: "#918C9E",
        6: "#716C7F",
        7: "#565165",
        8: "#433E52",
        9: "#363145"
      }
    },
    radius: {
      small: "0.3rem",
      big: "1.5rem"
    },
    padding: {
      small: "0.75rem",
      big: "1.25rem"
    },
    font: {
      size: {
        0: "0.6875rem",
        1: "0.8125rem",
        2: "0.9375rem",
        3: "1rem",
        4: "1.125rem",
        5: "1.25rem",
        6: "1.375rem"
      },
      weight: {
        regular: 500,
        bold: 600
      }
    },
    shadow: {
      small: "0px 2px 3px rgba(0, 0, 0, 0.12)",
      big: "0px 2px 3px rgba(0, 0, 0, 0.12), 0px 4px 8px rgba(48, 48, 48, 0.1)"
    },
    timing: {
      "short": "85ms",
      medium: "150ms",
      "long": "250ms"
    }
  };
  var a = {
    primary: function primary(r) {
      return void 0 === r && (r = "medium"), function (n) {
        return t(n).color.primary[r];
      };
    },
    grey: function grey(r) {
      return void 0 === r && (r = 0), function (n) {
        return t(n).color.grey[r];
      };
    },
    error: function error(r) {
      return void 0 === r && (r = "medium"), function (n) {
        return t(n).color.error[r];
      };
    }
  };

  function s(r) {
    return void 0 === r && (r = "big"), function (n) {
      return t(n).radius[r];
    };
  }

  function l(r) {
    return void 0 === r && (r = "big"), function (n) {
      return t(n).padding[r];
    };
  }

  function d(r) {
    return void 0 === r && (r = "big"), function (n) {
      return t(n).shadow[r];
    };
  }

  var c,
      g,
      m,
      u,
      f,
      h,
      p,
      b,
      x,
      y,
      w,
      v,
      k,
      z = {
    size: function size(r) {
      return void 0 === r && (r = 0), function (n) {
        return t(n).font.size[r];
      };
    },
    weight: function weight(r) {
      return void 0 === r && (r = "regular"), function (n) {
        return t(n).font.weight[r];
      };
    }
  },
      E = r.createGlobalStyle(c = c || e(["\n  @import url('https://rsms.me/inter/inter.css');\n  html {\n    font-family: 'Inter', sans-serif;\n    font-size: 100%;\n    -webkit-text-size-adjust: 100%;\n    box-sizing: border-box;\n    overflow: hidden;\n  }\n\n  body {\n    margin: 0;\n    padding: 0;\n  }\n  *, *:before, *:after {\n    box-sizing: inherit;\n  }\n  hr {\n    border-color: #EDECF3;\n    color: #EDECF3;\n    margin-bottom: 1.5rem;\n    margin-left: -1.25rem;\n    margin-right: -1.25rem;\n    border-top: 1px solid #EDECF3;\n    border-bottom: none;\n    height: 0;\n    box-sizing: content-box;\n  }\n  h1, h2, h3, h4, h5, h6, p {\n    &:first-child {\n      margin-top: 0;\n    }\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n"], ["\n  @import url('https://rsms.me/inter/inter.css');\n  html {\n    font-family: 'Inter', sans-serif;\n    font-size: 100%;\n    -webkit-text-size-adjust: 100%;\n    box-sizing: border-box;\n    overflow: hidden;\n  }\n\n  body {\n    margin: 0;\n    padding: 0;\n  }\n  *, *:before, *:after {\n    box-sizing: inherit;\n  }\n  hr {\n    border-color: #EDECF3;\n    color: #EDECF3;\n    margin-bottom: 1.5rem;\n    margin-left: -1.25rem;\n    margin-right: -1.25rem;\n    border-top: 1px solid #EDECF3;\n    border-bottom: none;\n    height: 0;\n    box-sizing: content-box;\n  }\n  h1, h2, h3, h4, h5, h6, p {\n    &:first-child {\n      margin-top: 0;\n    }\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n"])),
      F = r.css(g = g || e(["\n  -webkit-font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n  backface-visibility: visible;\n  background-color: transparent;\n  background-image: none;\n  border-color: transparent;\n  border-image: initial;\n  border-radius: 0px;\n  border-style: none;\n  border-width: 0px;\n  bottom: auto;\n  box-shadow: none;\n  box-sizing: border-box;\n  box-sizing: content-box;\n  caption-side: top;\n  clear: none;\n  clip: auto;\n  color: inherit;\n  cursor: auto;\n  direction: ltr;\n  display: inline;\n  float: none;\n  font-size: 100%;\n  font-stretch: normal;\n  font-style: normal;\n  font-variant: normal;\n  font-weight: normal;\n  height: auto;\n  left: auto;\n  letter-spacing: normal;\n  line-height: inherit;\n  margin: 0px;\n  max-height: none;\n  max-width: none;\n  min-height: 0px;\n  min-width: 0px;\n  opacity: 1;\n  outline-offset: 0px;\n  overflow-wrap: normal;\n  overflow: hidden;\n  padding: 0px;\n  perspective-origin: 50% 50%;\n  perspective: none;\n  pointer-events: auto;\n  position: static;\n  quotes: none;\n  resize: none;\n  right: auto;\n  size: auto;\n  table-layout: auto;\n  text-align-last: initial;\n  text-align: start;\n  text-decoration: none;\n  text-indent: 0px;\n  text-shadow: none;\n  text-transform: none;\n  top: auto;\n  transform-origin: 50% 50% 0px;\n  transform: none;\n  vertical-align: baseline;\n  white-space: normal;\n  word-break: normal;\n  word-spacing: normal;\n  font-family: 'Inter', sans-serif;\n"], ["\n  -webkit-font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n  backface-visibility: visible;\n  background-color: transparent;\n  background-image: none;\n  border-color: transparent;\n  border-image: initial;\n  border-radius: 0px;\n  border-style: none;\n  border-width: 0px;\n  bottom: auto;\n  box-shadow: none;\n  box-sizing: border-box;\n  box-sizing: content-box;\n  caption-side: top;\n  clear: none;\n  clip: auto;\n  color: inherit;\n  cursor: auto;\n  direction: ltr;\n  display: inline;\n  float: none;\n  font-size: 100%;\n  font-stretch: normal;\n  font-style: normal;\n  font-variant: normal;\n  font-weight: normal;\n  height: auto;\n  left: auto;\n  letter-spacing: normal;\n  line-height: inherit;\n  margin: 0px;\n  max-height: none;\n  max-width: none;\n  min-height: 0px;\n  min-width: 0px;\n  opacity: 1;\n  outline-offset: 0px;\n  overflow-wrap: normal;\n  overflow: hidden;\n  padding: 0px;\n  perspective-origin: 50% 50%;\n  perspective: none;\n  pointer-events: auto;\n  position: static;\n  quotes: none;\n  resize: none;\n  right: auto;\n  size: auto;\n  table-layout: auto;\n  text-align-last: initial;\n  text-align: start;\n  text-decoration: none;\n  text-indent: 0px;\n  text-shadow: none;\n  text-transform: none;\n  top: auto;\n  transform-origin: 50% 50% 0px;\n  transform: none;\n  vertical-align: baseline;\n  white-space: normal;\n  word-break: normal;\n  word-spacing: normal;\n  font-family: 'Inter', sans-serif;\n"])),
      C = o.div(m = m || e(["\n  ", "\n  * {\n    ", "\n  }\n"], ["\n  ", "\n  * {\n    ", "\n  }\n"]), F, F),
      D = o.button(y = y || e(["\n  text-align: center;\n  border: 0;\n  border-radius: ", ";\n  box-shadow: ", ";\n  background-color: ", ";\n  border: 1px solid ", ";\n  color: ", ";\n  fill: ", ";\n  font-weight: 500;\n  cursor: pointer;\n  font-size: ", ";\n  height: 2.5rem;\n  padding: 0 ", ";\n  transition: all 85ms ease-out;\n\n  &:hover {\n    background-color: ", ";\n  }\n  &:active {\n    background-color: ", ";\n    outline: none;\n  }\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"], ["\n  text-align: center;\n  border: 0;\n  border-radius: ", ";\n  box-shadow: ", ";\n  background-color: ", ";\n  border: 1px solid ", ";\n  color: ", ";\n  fill: ", ";\n  font-weight: 500;\n  cursor: pointer;\n  font-size: ", ";\n  height: 2.5rem;\n  padding: 0 ", ";\n  transition: all 85ms ease-out;\n\n  &:hover {\n    background-color: ", ";\n  }\n  &:active {\n    background-color: ", ";\n    outline: none;\n  }\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"]), s(), d("small"), a.grey(), a.grey(2), a.primary(), a.primary(), z.size(1), l(), a.grey(1), a.grey(2), function (n) {
    return n.disabled && r.css(u = u || e(["\n      opacity: 0.3;\n      pointer: not-allowed;\n      pointer-events: none;\n    "], ["\n      opacity: 0.3;\n      pointer: not-allowed;\n      pointer-events: none;\n    "]));
  }, function (n) {
    return n.primary && r.css(f = f || e(["\n      background-color: ", ";\n      color: ", ";\n      fill: ", ";\n      border: none;\n      &:hover {\n        background-color: ", ";\n      }\n      &:active {\n        background-color: ", ";\n      }\n    "], ["\n      background-color: ", ";\n      color: ", ";\n      fill: ", ";\n      border: none;\n      &:hover {\n        background-color: ", ";\n      }\n      &:active {\n        background-color: ", ";\n      }\n    "]), a.primary(), a.grey(), a.grey(), a.primary("light"), a.primary("dark"));
  }, function (n) {
    return n.small && r.css(h = h || e(["\n      height: 2rem;\n      font-size: ", ";\n      padding: 0 ", ";\n    "], ["\n      height: 2rem;\n      font-size: ", ";\n      padding: 0 ", ";\n    "]), z.size(0), l());
  }, function (n) {
    return n.margin && r.css(p = p || e(["\n      &:not(:first-child) {\n        margin-left: 0.5rem;\n      }\n    "], ["\n      &:not(:first-child) {\n        margin-left: 0.5rem;\n      }\n    "]));
  }, function (n) {
    return n.grow && r.css(b = b || e(["\n      flex-grow: 1;\n    "], ["\n      flex-grow: 1;\n    "]));
  }, function (n) {
    return n.busy && r.css(x = x || e(["\n      cursor: wait;\n    "], ["\n      cursor: wait;\n    "]));
  }),
      j = o(D)(k = k || e(["\n  padding: 0;\n  width: 2rem;\n  height: 2rem;\n  margin: 0;\n  position: relative;\n  transform-origin: 50% 50%;\n  transition: all 150ms ease-out;\n  padding: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  svg {\n    width: 1.625rem;\n    height: 1.625rem;\n  }\n\n  ", ";\n\n  ", ";\n"], ["\n  padding: 0;\n  width: 2rem;\n  height: 2rem;\n  margin: 0;\n  position: relative;\n  transform-origin: 50% 50%;\n  transition: all 150ms ease-out;\n  padding: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  svg {\n    width: 1.625rem;\n    height: 1.625rem;\n  }\n\n  ", ";\n\n  ", ";\n"]), function (n) {
    return n.small && r.css(w = w || e(["\n      width: 1.75rem;\n      height: 1.75rem;\n      padding: 0;\n\n      svg {\n        width: 1.5rem;\n        height: 1.5rem;\n      }\n    "], ["\n      width: 1.75rem;\n      height: 1.75rem;\n      padding: 0;\n\n      svg {\n        width: 1.5rem;\n        height: 1.5rem;\n      }\n    "]));
  }, function (n) {
    return n.open && r.css(v = v || e(["\n      transform: rotate(45deg);\n      background-color: ", ";\n      border-color: ", ";\n      outline: none;\n      fill: ", ";\n      &:hover {\n        background-color: ", ";\n      }\n      &:active {\n        background-color: ", ";\n      }\n    "], ["\n      transform: rotate(45deg);\n      background-color: ", ";\n      border-color: ", ";\n      outline: none;\n      fill: ", ";\n      &:hover {\n        background-color: ", ";\n      }\n      &:active {\n        background-color: ", ";\n      }\n    "]), a.grey(), a.grey(2), a.primary(), a.grey(1), a.grey(2));
  });
  n.Button = D, n.DefaultTheme = i, n.GlobalStyles = E, n.IconButton = j, n.TinaReset = C, n.TinaResetStyles = F, n.color = a, n.font = z, n.padding = l, n.radius = s, n.shadow = d, n.timing = function (r) {
    return function (n) {
      return t(n).timing[r];
    };
  }, Object.defineProperty(n, "__esModule", {
    value: !0
  });
});